import PropTypes from 'prop-types';
import React from 'react';
import styles from './UpgradeStrip.less';
import Tooltip from 'wix-style-react/Tooltip';
import Button from 'wix-style-react/Button';
import InfoIcon from '../Svg/Info';

export default class extends React.Component {
    static propTypes = {
        onPremium: PropTypes.func.isRequired,
        onSecondaryButton: PropTypes.func,
        primaryButtonText: PropTypes.string,
        secondaryButtonText: PropTypes.string,
        text: PropTypes.string.isRequired,
        className: PropTypes.string,
        tip: PropTypes.string
    };

    static defaultProps = {
        className: ''
    };

    render() {
        const { text, tip } = this.props;
        const className = this._getClassName();
        const buttons = this._getButtons();
        return (
            <div className={className}>
                <Tooltip content={<div style={{wordWrap: 'normal'}}>{tip}</div>}
                         placement={'top'}
                         alignment={'center'}
                         theme={'light'}
                         showTrigger={'mouseenter'}
                         hideTrigger={'mouseleave'}
                         showDelay={50}
                         onActiveChange={() => {}}
                         hideDelay={50}>
                    <div className={styles.help}><InfoIcon className={styles.helpTip}/></div>
                </Tooltip>
                <div className={styles.text}>{text}</div>
                {buttons}
            </div>
        );
    }

    _getClassName = () => {
        const { className, onSecondaryButton } = this.props;
        let cls = `${styles.wrapper} ${className}`;
        return cls + ` ${onSecondaryButton ? styles.double : ''}`;
    };

    _getButtons = () => {
        const { onPremium, primaryButtonText } = this.props;
        const secondaryButton = this._getSecondaryButton();
        return (
            <div className={styles.buttons}>
                <div className={`${styles.button} ${styles.secondary}`}>{secondaryButton}</div>
                <div className={styles.button}><Button onClick={onPremium} theme="fullpurple">{primaryButtonText}</Button></div>
            </div>
        );
    };

    _getSecondaryButton = () => {
        const { onSecondaryButton, secondaryButtonText } = this.props;
        return onSecondaryButton ? (
            <Button onClick={onSecondaryButton} theme="emptypurple">{secondaryButtonText}</Button>
        ) : null;
    };
}
